import { CommonMainPage } from '../../widgets/utility/CommonMainPage'
import { SerpPresenceFilters } from './widgets/serp-presence-filters/SerpPresenceFilters'
import { SerpPresenceTable } from './widgets/serp-presence-table/SerpPresenceTable'
import { useAppSelector } from '../../app/store/hooks/Redux'
import { selectProject } from './model/serpPresenceSlice'
import { PreparingDataStub } from '../../lib/widgets/stubs/PreparingDataStub'
import { StubLayout } from '../../lib/widgets/stubs/StubLayout'
import { ActionsSlotProvider } from '../../shared/components/utility/actions-slot/ActionsSlot'
import clsx from 'clsx'

import styles from './SERPPresencePage.module.scss'
import { useTranslation } from 'react-i18next'
import { useMenuLayout } from '../../app/layouts/main-layout/hooks/UseMenuLayout'

export const SERPPresencePage = () => {
  const { t } = useTranslation()
  const { menuLayout } = useMenuLayout()
  const { has_paid_links: hasPaidLinks } = useAppSelector(selectProject)

  return (
    <CommonMainPage
      hint={t('navigation.hint.onSiteBrandMentions')}
      title={t('navigation.onSiteBrandMentions')}
    >
      <ActionsSlotProvider>
        <section
          className={clsx(styles.wrapper, menuLayout === 'top' ? 'gap-[50px]' : 'gap-[24px]')}
        >
          <SerpPresenceFilters />
          {hasPaidLinks ? (
            <SerpPresenceTable />
          ) : (
            // над заглушкой gap колонки страницы и пустая строка чипов фильтров (8px)
            <StubLayout gap={(menuLayout === 'top' ? 50 : 24) + 8}>
              <PreparingDataStub />
            </StubLayout>
          )}
        </section>
      </ActionsSlotProvider>
    </CommonMainPage>
  )
}
